// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_yC3vd {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._hotkey_ohHBi {
  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  padding-inline: var(--form-element-label-offset);
}
._hotkey_ohHBi:first-child ._hotkey__label_au-to,
._hotkey_ohHBi:first-child ._hotkey__keys_4Mi3z {
  border-block-start: none;
}
._hotkey__label_au-to,
._hotkey__keys_4Mi3z {
  display: flex;
  align-items: center;
  padding-block: calc(2 * var(--default-grid-baseline));
  border-block-start: 1px solid var(--color-border);
}
._hotkey__label_au-to {
  flex: 1 1 200px;
}
._hotkey__keys_4Mi3z {
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: end;
  row-gap: calc(1 * var(--default-grid-baseline));
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcHotkey-CvuY7fQJ.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8FAA8F;EAC9F,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,gDAAgD;AAClD;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,+CAA+C;AACjD","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_yC3vd {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._hotkey_ohHBi {\n  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: stretch;\n  padding-inline: var(--form-element-label-offset);\n}\n._hotkey_ohHBi:first-child ._hotkey__label_au-to,\n._hotkey_ohHBi:first-child ._hotkey__keys_4Mi3z {\n  border-block-start: none;\n}\n._hotkey__label_au-to,\n._hotkey__keys_4Mi3z {\n  display: flex;\n  align-items: center;\n  padding-block: calc(2 * var(--default-grid-baseline));\n  border-block-start: 1px solid var(--color-border);\n}\n._hotkey__label_au-to {\n  flex: 1 1 200px;\n}\n._hotkey__keys_4Mi3z {\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  justify-content: end;\n  row-gap: calc(1 * var(--default-grid-baseline));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
